import React from 'react';

export const Slat63mm = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__slat" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__bslat">
        <use xlinkHref="#prefix__slat" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__bslat)"
        fill="#fff"
        stroke="#233762"
        strokeWidth={4.853}
        strokeMiterlimit={10}
      >
        <path d="M49.5 120l-63.4-6.1V82l81.5 7.3z" />
        <path d="M49.5 95l-63.4-6.1V57l81.5 7.3z" />
        <path d="M49.5 70l-63.4-6.1V32l81.5 7.3z" />
        <path d="M49.5 45l-63.4-6.1V7l81.5 7.3z" />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
